import type { PermissionMapping } from './permissions-types';

// API route permissions: search, analytics, industry, map, analysis
export const CORE_API_PERMISSIONS: PermissionMapping[] = [
  // Search
  {
    path: '/api/search/metrics',
    permission: 'admin.view',
    name: 'Use Search Metrics API',
    description: 'Access to search metrics API',
  },

  // Analytics
  {
    path: '/api/analytics/company-tax-rates',
    permission: 'metrics.view',
    name: 'View Company Tax Rates',
    description: 'Access to company tax rates API',
  },
  {
    path: '/api/analytics/balance-distribution',
    permission: 'metrics.view',
    name: 'View Balance Distribution',
    description: 'Access to balance distribution API',
  },
  {
    path: '/api/analytics/revenue-by-nace',
    permission: 'metrics.view',
    name: 'View Revenue by NACE',
    description: 'Access to revenue by NACE API',
  },
  {
    path: '/api/analytics/aggregated-revenue',
    permission: 'metrics.view',
    name: 'View Aggregated Revenue',
    description: 'Access to aggregated revenue API',
  },
  {
    path: '/api/analytics/company-cities',
    permission: 'metrics.view',
    name: 'View Company Cities',
    description: 'Access to company cities API',
  },
  {
    path: '/api/analytics/ai-cost-hourly',
    permission: 'metrics.view',
    name: 'View AI Cost Hourly',
    description: 'Access to AI cost hourly API',
  },

  // NACE / Industry
  {
    path: '/api/nace/coverage',
    permission: 'nace.view',
    name: 'View NACE Coverage',
    description: 'Access to NACE coverage API',
  },
  {
    path: '/api/industries',
    permission: 'industry.view',
    name: 'View Industries',
    description: 'Access to industries API',
  },
  {
    path: '/api/industries/[code]/details',
    permission: 'industry.view',
    name: 'View Industry Details',
    description: 'Access to industry specific analytics',
  },
  {
    path: '/api/nace/[code]/stats',
    permission: 'nace.view',
    name: 'View NACE Stats',
    description: 'Access to NACE stats API',
  },
  {
    path: '/api/nace/[code]/companies',
    permission: 'nace.view',
    name: 'View NACE Companies',
    description: 'Access to NACE companies API',
  },
  {
    path: '/api/nace_match',
    permission: 'nace.user',
    name: 'Use NACE Match',
    description: 'Access to NACE match API',
  },

  // Map
  {
    path: '/api/map/nace-sectors',
    permission: 'map.view',
    name: 'View NACE Sectors',
    description: 'Access to NACE sectors API',
  },
  {
    path: '/api/map/nace-subsectors',
    permission: 'map.view',
    name: 'View NACE Subsectors',
    description: 'Access to NACE subsectors API',
  },

  // Analysis
  {
    path: '/api/analysis',
    permission: 'analysis.view',
    name: 'Use Analysis API',
    description: 'Access to analysis API',
  },
];
